<template>
  <div
    class="menu-node-item"
    @mouseenter="testPosAndFix"
  >
    <div
      v-if="!menuBox"
      class="item-title"
    >
      <router-link
        v-if="type === 'link'"
        :to="url"
      >
        {{ title }}
      </router-link>
      <a
        v-if="type === 'event'"
        href="#"
        @click="action"
      >
        {{ title }}
      </a>
    </div>
    <div
      v-if="childNodes && childNodes.length > 0"
      class="item-children"
      :class="{'menu-box': menuBox, 'inner-children': !menuBox}"
    >
      <menu-node
        v-for="(nItem, index) in childNodes"
        :key="index"
        :type="nItem.type || 'link'"
        :title="nItem.title"
        :url="nItem.url"
        :action="nItem.action"
        :child-nodes="nItem.children"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuNode',
  props: {
    menuBox: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 菜单条目显示的文字
     */
    title: {
      type: String,
      default: '菜单条目',
    },
    /**
     * 当type定义未link时，点击菜单条目后跳转至该地址
     */
    url: {
      type: String,
      default: '',
    },
    /**
     * 标识该菜单条目的点击的行为
     * 接受link，event两个值
     */
    type: {
      type: String,
      default: 'link',
    },
    /**
     * 当type被定义未event时，调用该函数
     */
    action: {
      type: Function,
      default: () => {},
    },
    /**
     * 子节点数据对象数组
     */
    childNodes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {

    };
  },
  methods: {
    testPosAndFix: function () {
      const el = this.$el
      if(el.getElementsByClassName('inner-children').length > 0) {
        const menuList = el.getElementsByClassName('inner-children')[0]
        const absXY = this.getElementPagePosition(menuList)
        let top = 0
        if(menuList.style.top) {
          top = parseInt(menuList.style.top.slice(0, -2))
        }
        const overflowLen = window.innerHeight - (absXY.y + menuList.clientHeight)
        const afterFixLen = window.innerHeight - (absXY.y - top + menuList.clientHeight)
        if(overflowLen < 0) {
          menuList.style.top = overflowLen - 20 + 'px'
        } else {
          if(afterFixLen > 0) {
            menuList.style.top = '0'
          }
        }
      }
    },
    getElementPagePosition: function(element){
      //计算x坐标
      let actualLeft = element.offsetLeft;
      let current = element.offsetParent;
      while (current !== null){
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
      }
      //计算y坐标
      let actualTop = element.offsetTop;
      current = element.offsetParent;
      while (current !== null){
        actualTop += (current.offsetTop+current.clientTop);
        current = current.offsetParent;
      }
      //返回结果
      return {x: actualLeft, y: actualTop}
    }
  }
};
</script>

<style lang="less" scoped>
    .menu-node-item{
        position: relative;
        z-index: 9999;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin: 0;
        padding: 10px 0;
        a{
            color:rgba(255,255,255,1);
            text-decoration: none;
            font-size: 17px;
            min-height: 18px;
            display: block;
            line-height: 17px;
            letter-spacing: 2px;
        }
        .menu-node-item .menu-node-item a{
          font-weight: unset;
          font-size: 16px;
        }
    }
    .item-children{
        display: none;
    }
    .inner-children{
        position: absolute;
        top: 0;
        width:160px;
        right:-160px;
        background:rgba(0,0,0,0.6);
    }
    .menu-box {
        display: block;
        > .menu-node-item {
            text-align: left;
            width: calc(100% - 4px);
            margin: auto auto 20px;
            border-left: 4px solid transparent;
            > .item-title {
                width: 120px;
                margin: auto;
            }
            .menu-node-item{
                margin: 0;
                text-align: center;
                font-size:20px;

                font-weight:400;
                color:rgba(255,255,255,1);
            }
        }
        > .menu-node-item:hover {
            border-color: #E6061F!important;
            .menu-node-item:hover{
                background:rgba(0,0,0,1);
            }
        }
        .menu-node-item:hover{
            > .item-children {
                display: block;
            }
        }
    }

</style>
